// export var baseUrl = 'https://hg.gzmao8.com/api';
 // export var baseUrl = "http://test1.djzysm.com"; //测试
// export var baseUrl = "https://api.djzysm.com";
// export var baseUrl = "http://test.djzysm.com";
   export var baseUrl = "https://m.djzysm.com/";  //正式

export var JWT_TOKEN = "EW_JWT_TOKEN";




// WEBPACK FOOTER //
// ./src/config/config.js